import { render } from "./TheCartAddedProduct.vue?vue&type=template&id=59c7e40a"
import script from "./TheCartAddedProduct.vue?vue&type=script&lang=js"
export * from "./TheCartAddedProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__